var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col mt-3"},_vm._l((_vm.documentids),function(docid){return _c('div',{key:docid},[_c('document-display',{staticClass:"mb-3",attrs:{"documentid":docid}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }